// This script is meant to be included in the script bundle so that heatmap and tracker will always run on all pages without them having to call themselves.
// You'll still be able to include the mouse scripts in other files, without re-initializing it immediatly on your current page.
// For example if you want to create a widget that shows a heat map.

import heatmap from './heatmap';
import tracking from './tracking';

tracking.initTracker();
heatmap.initMap();